/* bvm-menu-mobile.js — MENU MOBILE, sotto i 1000 px (sessione M, notte 29→30/10/2026). Markup: snippets/bvm-menu-mobile.liquid ·
   stile: assets/bvm-menu-mobile.css. Qui: apri/chiudi del pannello (dock, velo, Esc, ×), fuoco e trappola del Tab, blocco dello
   scorrimento della pagina, il carrello del dock (mini carrello del tema, numero copiato), le AREE
   Prodotti (indice ↔ area, la barra che segue lo scorrimento della pila, la griglia «Tutte» con le tessere costruite all'avvio dalle
   schede, le linguette che portano alla cartellina, le foto caricate all'apertura dell'area). Le pile sono CSS (position: sticky): qui si
   leggono solo le posizioni; Showroom e Contatti (lotto 3) con l'apertura calcolata in ora di Roma; la ricerca con invito e giro
   condivisi col desktop (window.bvmMm). Da 1000 px in su niente. Il CDN di Shopify serve gli script già minificati: qui si scrive leggibile. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 999px)');
  var ridotto = window.matchMedia('(prefers-reduced-motion: reduce)');
  var html = document.documentElement;
  var radice, pannello, velo, dockMenu, campo, scorriIndice, scorriArea, vistaIndice, vistaArea, griglia, barra;
  var ultimoFuoco = null, aperto = false, areaAperta = null, schede = [], segmenti = [], attiva = -1, tick = false;
  var naturali = null, naturaliArea = {};

  function el(sel, da) { return (da || radice).querySelector(sel); }
  function tutti(sel, da) { return Array.prototype.slice.call((da || radice).querySelectorAll(sel)); }
  function scorriA(cont, y) { try { cont.scrollTo({ top: Math.max(0, y), behavior: ridotto.matches ? 'auto' : 'smooth' }); } catch (e) { cont.scrollTop = Math.max(0, y); } }
  function fuoco(e) { if (e && e.focus) { try { e.focus({ preventScroll: true }); } catch (x) { e.focus(); } } }
  function variabile(nome, se) { return parseFloat(getComputedStyle(radice).getPropertyValue(nome)) || se; }
  /* le posizioni «naturali» (non appiccicate) si leggono con lo scorrimento a zero, alla prima apertura e dopo un cambio di misura */
  function misura(cont, lista) { var r0 = cont.getBoundingClientRect().top, st = cont.scrollTop; return lista.map(function (e) { return e.getBoundingClientRect().top - r0 + st; }); }

  /* ── pannello ── */
  function apri(modo) {
    if (aperto) { if (modo === 'cerca') { mostraIndice(); scorriIndice.scrollTop = 0; fuoco(campo); } return; }
    aperto = true;
    ultimoFuoco = document.activeElement;
    pannello.hidden = false; velo.hidden = false;
    html.classList.add('bvm-mob-aperto');
    dockMenu.setAttribute('aria-expanded', 'true');
    var testo = el('[data-bvm-mob-menu-testo]'); if (testo) testo.textContent = testo.getAttribute('data-chiudi');
    requestAnimationFrame(function () { pannello.classList.add('is-aperto'); });
    attiva = -1;
    if (modo === 'cerca') { mostraIndice(); scorriIndice.scrollTop = 0; fuoco(campo); } else fuoco(scorriIndice);
    aggiornaBarra();
  }
  function chiudi() {
    if (!aperto) return;
    aperto = false;
    chiudiGriglia();
    mostraIndice(); /* alla riapertura si riparte dall'indice */
    pannello.classList.remove('is-aperto');
    pannello.hidden = true; velo.hidden = true;
    html.classList.remove('bvm-mob-aperto');
    dockMenu.setAttribute('aria-expanded', 'false');
    var testo = el('[data-bvm-mob-menu-testo]'); if (testo) testo.textContent = testo.getAttribute('data-apri');
    if (ultimoFuoco && ultimoFuoco.focus && document.contains(ultimoFuoco) && !pannello.contains(ultimoFuoco)) fuoco(ultimoFuoco); else fuoco(dockMenu);
  }

  /* ── indice ↔ area ── */
  function mostraIndice() {
    if (!vistaArea) return;
    tutti('[data-bvm-mob-area]', vistaArea).forEach(function (a) { a.hidden = true; });
    vistaArea.hidden = true; vistaIndice.hidden = false;
    areaAperta = null;
  }
  function apriArea(h) {
    var sez = vistaArea && el('[data-bvm-mob-area="' + h + '"]', vistaArea);
    if (!sez) return;
    chiudiGriglia();
    tutti('[data-bvm-mob-area]', vistaArea).forEach(function (a) { a.hidden = (a !== sez); });
    /* le foto delle sottocategorie: l'indirizzo sta in data-bvm-mob-src, si copia in src la prima volta */
    tutti('img[data-bvm-mob-src]', sez).forEach(function (im) { im.src = im.getAttribute('data-bvm-mob-src'); im.removeAttribute('data-bvm-mob-src'); });
    vistaIndice.hidden = true; vistaArea.hidden = false;
    scorriArea.scrollTop = 0;
    areaAperta = h;
    if (h === 'showroom' || h === 'contatti') mostraApertura();
    fuoco(el('[data-bvm-mob-indietro]', sez));
  }
  function indietro() {
    var h = areaAperta;
    mostraIndice();
    fuoco(h && el('[data-bvm-mob-scheda="' + h + '"]') || scorriIndice);
  }

  /* ── la barra: segue la scheda in cima alla pila (la pila è CSS; qui si confrontano le posizioni) ── */
  function schedaTop(i) { return (barra ? barra.offsetHeight : 76) + 14 + i * variabile('--mob-passo-schede', 12); }
  function naturaliSchede() { if (!naturali) { var st = scorriIndice.scrollTop; scorriIndice.scrollTop = 0; naturali = misura(scorriIndice, schede); scorriIndice.scrollTop = st; } return naturali; }
  function aggiornaBarra() {
    if (!barra || !schede.length || vistaIndice.hidden || pannello.hidden) return;
    var nat = naturaliSchede(), st = scorriIndice.scrollTop, i, nuova = 0;
    for (i = 0; i < schede.length; i++) { if (nat[i] - st <= schedaTop(i) + 2) nuova = i; else break; }
    if (nuova === attiva) return;
    attiva = nuova;
    var s = schede[nuova], nome = el('[data-bvm-mob-barra-nome]'), num = el('[data-bvm-mob-barra-num]'), ico = el('[data-bvm-mob-barra-icona]');
    if (nome) nome.textContent = s.getAttribute('data-nome') || '';
    if (num) num.textContent = (nuova + 1 < 10 ? '0' : '') + (nuova + 1);
    if (ico) { var sv = s.querySelector('svg'); ico.innerHTML = sv ? sv.outerHTML : ''; }
    segmenti.forEach(function (sg, k) { sg.className = k < nuova ? 'is-fatto' : (k === nuova ? 'is-attivo' : ''); });
    tutti('[data-bvm-mob-tile]').forEach(function (t, k) { t.classList.toggle('is-attiva', k === nuova); });
  }
  function vaiAScheda(i) { if (schede[i]) scorriA(scorriIndice, naturaliSchede()[i] - schedaTop(i) + 1); }

  /* ── la griglia «Tutte»: le tessere nascono dalle schede (numero, icona, nome corto, sottotitolo; un link se la scheda è un link) ── */
  function costruisciGriglia() {
    var cont = el('[data-bvm-mob-tiles]'); if (!cont || cont.children.length) return;
    schede.forEach(function (s, i) {
      var link = s.tagName === 'A', t = document.createElement(link ? 'a' : 'button');
      t.className = 'bvm-mob-tile'; t.setAttribute('data-bvm-mob-tile', String(i));
      if (link) t.href = s.href;
      var num = s.querySelector('small b'), meta = s.querySelector('small'), sv = s.querySelector('svg');
      t.innerHTML = '<small>' + (num ? num.textContent : '') + '</small>' + (sv ? sv.outerHTML : '') + '<b></b><i></i>';
      t.querySelector('b').textContent = s.getAttribute('data-nome') || '';
      t.querySelector('i').textContent = meta ? meta.textContent.replace(num ? num.textContent : '', '').trim() : '';
      cont.appendChild(t);
    });
  }
  function apriGriglia() {
    if (!griglia) return;
    costruisciGriglia();
    griglia.hidden = false;
    var b = el('[data-bvm-mob-griglia-apri]'); if (b) b.setAttribute('aria-expanded', 'true');
    fuoco(el('[data-bvm-mob-tile].is-attiva', griglia) || el('[data-bvm-mob-tile]', griglia));
  }
  function chiudiGriglia(riporta) {
    if (!griglia || griglia.hidden) return;
    griglia.hidden = true;
    var b = el('[data-bvm-mob-griglia-apri]'); if (b) { b.setAttribute('aria-expanded', 'false'); if (riporta) fuoco(b); }
  }

  /* ── le linguette: portano la cartellina in cima (sotto la testa dell'area e le linguette già impilate) ── */
  function vaiACartellina(bottone) {
    var li = bottone.parentElement, sez = bottone.closest('[data-bvm-mob-area]'); if (!li || !sez) return;
    var h = sez.getAttribute('data-bvm-mob-area'), lista = tutti('.bvm-mob-cartellina', sez), i = lista.indexOf(li);
    if (!naturaliArea[h]) { var st = scorriArea.scrollTop; scorriArea.scrollTop = 0; naturaliArea[h] = misura(scorriArea, lista); scorriArea.scrollTop = st; }
    scorriA(scorriArea, naturaliArea[h][i] - (variabile('--mob-atesta-alto', 150) - 18 + i * variabile('--mob-passo-cartelline', 14)) + 1);
  }

  /* ── SIAMO APERTI? (lotto 3 del 03/11/2026): UNA funzione per il pannello Showroom e per il badge di Contatti. Ora di Roma con
     Intl (timeZone Europe/Rome; senza Intl, l'ora del telefono). Lun–ven 9:00–13:00 e 14:00–18:00; sabato solo su appuntamento;
     domenica chiuso. I testi stanno tutti nell'HTML (data-ap-stato, data-ap-fascia): qui si sceglie quale mostrare, si segna il giorno
     (data-ap-giorno, data-ap-riga) e si posiziona l'indicatore dell'ora sulla barra (data-ap-ora, 1 = 9–13, 2 = 14–18). */
  function apertura(adesso) {
    var d = adesso || new Date(), giorno, minuti;
    try {
      var v = {}; new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Rome', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(d).forEach(function (p) { v[p.type] = p.value; });
      giorno = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(v.weekday) + 1; minuti = (parseInt(v.hour, 10) % 24) * 60 + parseInt(v.minute, 10);
      if (!giorno || isNaN(minuti)) throw 0;
    } catch (e) { giorno = (d.getDay() + 6) % 7 + 1; minuti = d.getHours() * 60 + d.getMinutes(); }
    var stato, fascia, seg = 0, pos = 0;
    if (giorno === 6) { stato = 'sabato'; fascia = 'sabato'; }
    else if (giorno === 7) { stato = 'domenica'; fascia = 'domenica'; }
    else if (minuti < 540) { stato = 'chiuso'; fascia = 'prima'; }
    else if (minuti < 780) { stato = 'aperto'; fascia = 'mattina'; seg = 1; pos = (minuti - 540) / 240; }
    else if (minuti < 840) { stato = 'chiuso'; fascia = 'pausa'; }
    else if (minuti < 1080) { stato = 'aperto'; fascia = 'pomeriggio'; seg = 2; pos = (minuti - 840) / 240; }
    else { stato = 'chiuso'; fascia = giorno === 5 ? 'weekend' : 'sera'; }
    return { stato: stato, fascia: fascia, giorno: giorno, seg: seg, pos: pos };
  }
  function mostraApertura() {
    var a = apertura();
    tutti('[data-ap-stato]').forEach(function (e) { e.hidden = e.getAttribute('data-ap-stato') !== a.stato; });
    tutti('[data-ap-fascia]').forEach(function (e) { e.hidden = e.getAttribute('data-ap-fascia') !== a.fascia; });
    tutti('[data-ap-giorno]').forEach(function (e) { e.classList.toggle('is-oggi', parseInt(e.getAttribute('data-ap-giorno'), 10) === a.giorno); });
    tutti('[data-ap-riga]').forEach(function (e) { var r = e.getAttribute('data-ap-riga'); e.classList.toggle('is-oggi', (r === 'feriale' && a.giorno <= 5) || (r === 'sabato' && a.giorno === 6) || (r === 'domenica' && a.giorno === 7)); });
    tutti('[data-ap-ora]').forEach(function (e) { var s = parseInt(e.getAttribute('data-ap-ora'), 10); e.hidden = s !== a.seg; if (s === a.seg) e.style.left = (a.pos * 100).toFixed(1) + '%'; });
    tutti('[data-ap-radice]').forEach(function (e) { e.classList.toggle('is-aperto', a.stato === 'aperto'); e.classList.toggle('is-chiuso', a.stato !== 'aperto'); });
  }

  function via() {
    radice = document.getElementById('bvm-mob');
    if (!radice || radice.getAttribute('data-bvm-mob-pronto')) return;
    pannello = el('#bvm-mob-pannello'); velo = el('.bvm-mob-velo'); dockMenu = el('[data-bvm-mob-apri]'); campo = el('[data-bvm-mob-campo]');
    if (!pannello || !dockMenu) return;
    radice.setAttribute('data-bvm-mob-pronto', '1');
    /* fuori dall'header: dentro la sua sezione (sticky, col suo z-index) il dock e il pannello finirebbero sotto i contenuti della pagina */
    if (radice.parentElement !== document.body) document.body.appendChild(radice);
    html.classList.add('bvm-mob-on');
    vistaIndice = el('[data-bvm-mob-vista="indice"]'); vistaArea = el('[data-bvm-mob-vista="area"]');
    scorriIndice = el('[data-bvm-mob-scorri="indice"]'); scorriArea = el('[data-bvm-mob-scorri="area"]');
    griglia = el('#bvm-mob-griglia'); barra = el('[data-bvm-mob-barra]');
    schede = tutti('[data-bvm-mob-scheda]'); segmenti = tutti('[data-bvm-mob-segmenti] i');
    var testo = el('[data-bvm-mob-menu-testo]');
    if (testo) { testo.setAttribute('data-apri', testo.textContent); testo.setAttribute('data-chiudi', dockMenu.getAttribute('data-testo-chiudi') || 'Chiudi'); }
    costruisciGriglia();
    mostraApertura();
    /* il saluto secondo l'ora (mockup: «/ BUONASERA»): fino alle 13 buongiorno, fino alle 18 buon pomeriggio, poi buonasera */
    var saluto = el('[data-bvm-mob-saluto]');
    if (saluto) { var parti = saluto.getAttribute('data-bvm-mob-saluto').split('|'), ora = new Date().getHours(); saluto.textContent = '/ ' + (parti[ora < 13 ? 0 : (ora < 18 ? 1 : 2)] || parti[0]); }

    dockMenu.addEventListener('click', function () { if (aperto) chiudi(); else apri(); });
    /* «Cerca» nel dock è un link alla pagina di ricerca (lotto 2 del 03/11/2026, punto 4): niente da fare qui */
    radice.addEventListener('click', function (e) {
      var t = e.target, x;
      if (t.closest('[data-bvm-mob-chiudi]')) { chiudi(); return; }
      if ((x = t.closest('[data-bvm-mob-pannello]'))) { e.preventDefault(); apriArea(x.getAttribute('data-bvm-mob-pannello')); return; }
      if ((x = t.closest('[data-bvm-mob-scheda][data-apri]'))) { apriArea(x.getAttribute('data-bvm-mob-scheda')); return; }
      if (t.closest('[data-bvm-mob-indietro]')) { indietro(); return; }
      if (t.closest('[data-bvm-mob-griglia-apri]')) { if (griglia && !griglia.hidden) chiudiGriglia(true); else apriGriglia(); return; }
      if (t.closest('[data-bvm-mob-griglia-chiudi]')) { chiudiGriglia(true); return; }
      if ((x = t.closest('button[data-bvm-mob-tile]'))) { var i = parseInt(x.getAttribute('data-bvm-mob-tile'), 10); chiudiGriglia(); vaiAScheda(i); fuoco(schede[i]); return; }
      if ((x = t.closest('.bvm-mob-cartellina > button'))) { vaiACartellina(x); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (!aperto) return;
      if (e.key === 'Escape') { e.preventDefault(); if (griglia && !griglia.hidden) chiudiGriglia(true); else chiudi(); return; }
      /* Tab resta dentro al pannello (e nella griglia quando è aperta): è un dialogo modale */
      if (e.key === 'Tab') {
        var dentro = (griglia && !griglia.hidden) ? griglia : (areaAperta ? el('[data-bvm-mob-area]:not([hidden])', vistaArea) : vistaIndice);
        if (!dentro) return;
        var f = tutti('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', dentro).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        var primo = f[0], ultimo = f[f.length - 1], att = document.activeElement;
        if (e.shiftKey && (att === primo || !dentro.contains(att))) { e.preventDefault(); fuoco(ultimo); }
        else if (!e.shiftKey && (att === ultimo || !dentro.contains(att))) { e.preventDefault(); fuoco(primo); }
      }
    });
    window.addEventListener('resize', function () { naturali = null; naturaliArea = {}; attiva = -1; if (aperto) aggiornaBarra(); });
    if (scorriIndice) scorriIndice.addEventListener('scroll', function () { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; aggiornaBarra(); }); }, { passive: true });

    /* il carrello del dock: apre il mini carrello del tema (il suo pulsante nell'header, gestito da assets/theme.js); senza, resta il link /cart */
    var carrello = el('[data-bvm-mob-carrello]');
    if (carrello) carrello.addEventListener('click', function (e) {
      var t = document.querySelector('.header__cart-toggle[data-action="toggle-mini-cart"]');
      if (!t || !document.getElementById('mini-cart')) return;
      e.preventDefault(); if (aperto) chiudi(); t.click();
    });
    /* col mini carrello aperto (aria-hidden="false" su #mini-cart, alto quanto lo schermo) il dock si ritira: coprirebbe «Vai alla cassa» */
    var mc = document.getElementById('mini-cart');
    if (mc && window.MutationObserver) {
      var statoMc = function () { html.classList.toggle('bvm-mob-carrello-aperto', mc.getAttribute('aria-hidden') === 'false'); };
      new MutationObserver(statoMc).observe(mc, { attributes: true, attributeFilter: ['aria-hidden'] }); statoMc();
    }
    /* «Carrello (n)»: il tema aggiorna il suo pallino (.header__cart-count), qui si copia */
    var n = el('[data-bvm-mob-carrello-n]'), c = document.querySelector('.header__cart-count');
    if (n && c && window.MutationObserver) {
      var copia = function () { var t = c.textContent.trim(); n.textContent = t; n.hidden = (t === '0' || t === ''); };
      new MutationObserver(copia).observe(c, { childList: true, characterData: true, subtree: true }); copia();
    }
    /* la ricerca: INVITO che scorre e GIRO della linea al fuoco, le funzioni CONDIVISE col desktop (window.bvmMm, in testa ad
       assets/bvm-mega-menu.js — lotto 3 del 03/11/2026, niente seconda copia). Quello script è «defer» e nel DOM viene dopo questo:
       se non c'è ancora, si aspetta DOMContentLoaded (che arriva dopo tutti i defer). L'invito si muove solo a pannello aperto; con
       «riduci movimento» resta fermo e il giro è il solo filo (lo decidono loro). Le parole sono quelle del desktop (template
       data-bvm-mm-invito di snippets/bvm-mega-menu-riga.liquid). */
    var cercaForm = el('.bvm-mob-cerca');
    function effettiRicerca() {
      var mm = window.bvmMm, modello = document.querySelector('template[data-bvm-mm-invito]');
      if (!mm || !cercaForm || !campo) return;
      if (modello && mm.invito) mm.invito(function () { return campo; }, modello, function () { return aperto && mq.matches; });
      if (mm.giro && mm.togliGiro) {
        cercaForm.addEventListener('focusin', function (e) { if (e.target === campo) mm.giro(cercaForm, 0, 16); });
        cercaForm.addEventListener('focusout', function (e) { if (e.target === campo) mm.togliGiro(cercaForm); });
      }
    }
    if (window.bvmMm) effettiRicerca(); else document.addEventListener('DOMContentLoaded', effettiRicerca);
    /* Eventi: il link «…#eventi» della riga lo intercetta assets/bvm-eventi.js (in cattura sul documento, senza limiti di larghezza) e apre
       il <dialog> del pannello Eventi sopra tutto; qui, quando quel pannello si apre, il menu si chiude, così alla sua chiusura sotto c'è la
       pagina e non il menu (lo stesso che bvm-eventi.js fa col menu del tema). Senza pannello (nessun evento in programma) il link porta alla pagina. */
    var dlgEv = document.querySelector('dialog[data-vsb-pannello]');
    if (dlgEv && window.MutationObserver) new MutationObserver(function () { if (dlgEv.open && aperto) chiudi(); }).observe(dlgEv, { attributes: true, attributeFilter: ['open'] });
    /* se si passa sopra i 1000 px col pannello aperto, si chiude e la pagina torna a scorrere */
    var cambio = function (m) { if (!m.matches && aperto) chiudi(); };
    if (mq.addEventListener) mq.addEventListener('change', cambio); else if (mq.addListener) mq.addListener(cambio);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', via); else via();
})();
